import { ShowOption, PickupTimeOption } from '../types';
import { gettext } from '../../../utils/text';

/**
 * Determines the available pickup time options based on the selected show
 * and whether the cart contains restaurant-only items.
 *
 * Logic:
 * 1. Restaurant-only orders have a fixed pickup time (2 hours before event)
 * 2. If a show is selected with available pickup times, use those
 * 3. Otherwise, return default options (1 hour before or during break)
 *
 * Values are defined in aire_integration/models.py
 */
export const getOrderTypes = (
    selectedShow: ShowOption | null,
    hasRestaurantItem: boolean,
): PickupTimeOption[] => {
    // Restaurant-only orders have a fixed pickup time
    if (hasRestaurantItem) {
        return [
            {
                value: 3, // Restaurant order, value defined in aire_integration/models.py
                label: gettext('Two hours before event'),
            },
        ];
    }

    // If a show is selected, use its available pickup times
    if (
        selectedShow &&
        selectedShow.availablePickupTimes &&
        selectedShow.availablePickupTimes.length > 0
    ) {
        return selectedShow.availablePickupTimes;
    }

    // Default fallback options if no show selected or no options available
    return [
        {
            value: 1,
            label: gettext('An hour before event'),
        },
        {
            value: 2,
            label: gettext('During the break'),
        },
    ];
};
